import "core-js/modules/es6.function.name";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.regexp.replace";
import _typeof from "/home/runner/work/utopia-management/utopia-management/node_modules/@babel/runtime-corejs2/helpers/esm/typeof";
import "core-js/modules/es6.regexp.to-string";

/**
 * axios 1.x 兼容层：让 1.x 发出的请求与原 0.18.1 一致
 *
 * 1.x 与 0.18 在本项目用到的场景里有以下行为差异，这里逐一还原：
 * 1. FormData + 显式 Content-Type: application/json（多个导入页面就是这么写的）：
 *    0.18 会删掉 Content-Type，交给浏览器生成带 boundary 的 multipart；
 *    1.x 会把 FormData 转成 JSON 字符串发送，文件直接丢失。
 * 2. 字符串请求体 + Content-Type: application/json（request.js 拦截器对所有请求都这么设）：
 *    0.18 原样发送；1.x 会 trim，非合法 JSON 的字符串还会被再包一层引号。
 * 3. 对象请求体且没有显式 Content-Type：0.18 发 application/json;charset=utf-8，1.x 不带 charset；
 *    对象请求体 + multipart / urlencoded 的 Content-Type：0.18 一律 JSON，1.x 会改成表单编码。
 * 4. GET 的 params 序列化：0.18 对 @ [ ] 不转义、嵌套对象整体 JSON.stringify；
 *    1.x 会转义 @ [ ]，嵌套对象展开成 a[b]=c。
 *
 * 做法：把 0.18.1 的 transformRequest 和 buildURL 参数序列化原样搬过来，替换 1.x 的默认实现。
 * 只依赖传入的 axios 实例，不 import axios，方便脱离 webpack 单独做对比测试。
 */
var toString = Object.prototype.toString;

function isFormData(val) {
  return typeof FormData !== 'undefined' && val instanceof FormData;
}

function isArrayBuffer(val) {
  return toString.call(val) === '[object ArrayBuffer]';
}

function isArrayBufferView(val) {
  if (typeof ArrayBuffer !== 'undefined' && ArrayBuffer.isView) {
    return ArrayBuffer.isView(val);
  }

  return val && val.buffer && val.buffer instanceof ArrayBuffer;
}

function isFileOrBlob(val) {
  var tag = toString.call(val);
  return tag === '[object File]' || tag === '[object Blob]';
}

function isURLSearchParams(val) {
  return typeof URLSearchParams !== 'undefined' && val instanceof URLSearchParams;
} // 与 0.18.1 utils.forEach 完全一致


function forEach(obj, fn) {
  if (obj === null || typeof obj === 'undefined') {
    return;
  }

  if (_typeof(obj) !== 'object') {
    obj = [obj];
  }

  if (toString.call(obj) === '[object Array]') {
    for (var i = 0, l = obj.length; i < l; i++) {
      fn(obj[i], i);
    }
  } else {
    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        fn(obj[key], key);
      }
    }
  }
} // 与 0.18.1 helpers/buildURL.js 的 encode 完全一致


function encode(val) {
  return encodeURIComponent(val).replace(/%40/gi, '@').replace(/%3A/gi, ':').replace(/%24/g, '$').replace(/%2C/gi, ',').replace(/%20/g, '+').replace(/%5B/gi, '[').replace(/%5D/gi, ']');
}
/**
 * 0.18.1 buildURL 的参数序列化逻辑原样搬过来
 * null / undefined 跳过；数组拼成 key[]=a&key[]=b；Date 转 ISO；对象 JSON.stringify
 */


export function legacyParamsSerializer(params) {
  if (isURLSearchParams(params)) {
    return params.toString();
  }

  var parts = [];
  forEach(params, function (val, key) {
    if (val === null || typeof val === 'undefined') {
      return;
    }

    if (toString.call(val) === '[object Array]') {
      key = key + '[]';
    } else {
      val = [val];
    }

    forEach(val, function (v) {
      if (toString.call(v) === '[object Date]') {
        v = v.toISOString();
      } else if (v !== null && _typeof(v) === 'object') {
        v = JSON.stringify(v);
      }

      parts.push(encode(key) + '=' + encode(v));
    });
  });
  return parts.join('&');
} // 所有大小写形式的 Content-Type 头名（拦截器、业务页面里 'Content-Type' / 'content-type' 两种写法都有）

function contentTypeKeys(headers) {
  return Object.keys(headers || {}).filter(function (name) {
    return name.toLowerCase() === 'content-type';
  });
} // 与 0.18.1 setContentTypeIfUnset 一致：只有没设置 Content-Type 时才设置


function setContentTypeIfUnset(headers, value) {
  if (!headers) {
    return;
  }

  var isSet = contentTypeKeys(headers).some(function (name) {
    return typeof headers[name] !== 'undefined' && headers[name] !== null;
  });

  if (!isSet) {
    contentTypeKeys(headers).forEach(function (name) {
      return delete headers[name];
    });
    headers['Content-Type'] = value;
  }
}
/**
 * 0.18.1 defaults.transformRequest 原样搬过来
 * 唯一区别：FormData 时顺手删掉 Content-Type（0.18 是在 xhr 适配器里删的，效果相同）
 */


export function legacyTransformRequest(data, headers) {
  if (isFormData(data)) {
    contentTypeKeys(headers).forEach(function (name) {
      return delete headers[name];
    });
    return data;
  }

  if (isArrayBuffer(data) || isFileOrBlob(data)) {
    return data;
  }

  if (isArrayBufferView(data)) {
    return data.buffer;
  }

  if (isURLSearchParams(data)) {
    setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
    return data.toString();
  }

  if (data !== null && _typeof(data) === 'object') {
    setContentTypeIfUnset(headers, 'application/json;charset=utf-8');
    return JSON.stringify(data);
  }

  return data;
}
/**
 * 给 axios 实例装上兼容层（可重复调用）
 * axios.create 出来的实例会继承默认实例的 defaults，所以先装默认实例再 create 即可
 */

export function applyLegacyAxiosCompat(instance) {
  instance.defaults.transformRequest = [legacyTransformRequest];
  instance.defaults.paramsSerializer = legacyParamsSerializer;
  return instance;
}